import React from "react";

export const BvB: React.FC<{ className?: string }> = ({ className }) => (
  <img src="/assets/bvb-icon.svg" alt="BVB Vereinslogo" className={className} />
);
